import { gql, useQuery } from '@apollo/client';
import { DayAvailability, QueryListPackAvailabilityArgs } from 'apollo/generated/types';

const LIST_PACK_AVAILABILITY = gql`
  query listPackAvailability($id: ID!, $startDate: String!, $endDate: String!) {
    listPackAvailability(id: $id, startDate: $startDate, endDate: $endDate) {
      day
      remaining
      aggregateRemaining
      activityTimes {
        activityId
        activityTimeId
        startHour
        endHour
        hasSingleTimetable
        remaining
      }
    }
  }
`;

const useListPackAvailabilityQuery = (
  id: string,
  startDate: string,
  endDate: string,
  skip?: boolean
) => {
  const query = useQuery<
    { listPackAvailability: DayAvailability[] },
    QueryListPackAvailabilityArgs
  >(LIST_PACK_AVAILABILITY, {
    variables: { id, startDate, endDate },
    skip,
  });
  return query.data?.listPackAvailability;
};

export default useListPackAvailabilityQuery;
